export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}

export const USER_TYPE = {
    GUEST: "",
    ADMIN: '/admin',
}

export const NAVIGATE_ADMIN = {
    HOME: '/home',
    DASHBOARD:'/dashboard',
    QUOTATION: '/quotation',
    PROFORMA_INVOICE: '/proforma-invoice',
    TAX_INVOICE: '/tax-invoice',  
 
    get DASHBOARD_PAGE() { return `${USER_TYPE.ADMIN}${this.DASHBOARD}`; },
}
